import { render, staticRenderFns } from "./zsgl.vue?vue&type=template&id=47cbaab1&scoped=true"
import script from "./zsgl.vue?vue&type=script&lang=js"
export * from "./zsgl.vue?vue&type=script&lang=js"
import style0 from "../../views/member-page/assets/css/rem.css?vue&type=style&index=0&id=47cbaab1&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbaab1",
  null
  
)

export default component.exports